module.exports = __webpack_public_path__ + "img/12_3.adf80def.png";